<template>
    <div class="inoutcount">
        <div class="chart" ref="chart"></div>
    </div>
</template>

<script>
// import { getOption } from './inoutCount.js';
import { fontSize } from "@/util/common/fontSize";
import echarts from 'echarts';

export default {
    data() {
        return {
            myChart: null,
            dataOp: {},
            timer: null,
            allData: [],
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.chart);
        window.addEventListener("resize", this.resize);
        this.pageDataInit();
        this.timer = setInterval(() => {
            this.pageDataInit();
        }, 60 * 1000)
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
        clearInterval(this.timer);
    },
    methods: {
        async pageDataInit() {
            await this.getData();
            this.drawChart();
        },
        findCountByWasteName(_name, type) {
            let data = this.allData.inlist;
            if (type == 2) {
                data = this.allData.outlist;
            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].data === _name) {
                    return data[i].count;
                }
            }
            return 0;
        },
        getData() {
            var that = this;
            // 获取数据
            return this.$api.Waste.getWasteStatistics2({ content: this.search }, [
                "uuid",
                "company",
            ]).then((res) => {
                if (res.code == 0) {
                    this.allData = res.data;
                    // 获取成功
                    let topicList = []; // 标题
                    let dataList1 = []; // 数据值1
                    let dataList2 = []; // 数据值2
                    this.allData.inlist.map((res) => {
                        topicList.push(res.data);
                        dataList1.push(res.count);
                    });
                    this.allData.outlist.map((res) => {
                        dataList2.push(res.count);
                    });
                    let px16 = fontSize(16);
                    this.dataOp = {
                        color: ["#378BDC", "#EFBB36"],
                        grid: {
                            left: '3%',
                            right: '4%',
                            top: '8%',
                            bottom: '15%',
                            containLabel: true

                        },

                        legend: {
                            data: ['入库', '出库'],
                            icon: "circle",
                            top: 'bottom',
                            bottom: 20,
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        tooltip: {
                            trigger: "axis",
                            formatter: function (params) {
                                return (
                                    params[0].name +
                                    "<br/>入库重量:" + that.findCountByWasteName(params[0].name, 1) + "吨" +
                                    "<br/>出库重量:" + that.findCountByWasteName(params[0].name, 2) + "吨"
                                );
                            },
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                            textStyle: {
                                color: '#FFF',
                                fontSize: 14,
                                align: 'left',
                            },
                        },
                        // toolbox: {
                        //     show: true,
                        // },
                        xAxis: [
                            {
                                type: 'category',
                                // name: "月份",
                                data: topicList,
                                boundaryGap: true,
                                axisLine: {
                                    show: false // 刻度
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    color: "#fff",
                                    fontSize: fontSize(10),
                                    // align: "center",
                                    rotate: 45,
                                    formatter: function (value, index) {
                                        // return value.substring(0,2);
                                        return value;
                                    }
                                }
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                axisLine: {
                                    show: false
                                },
                                axisLabel: {
                                    color: "#fff",
                                    fontSize: fontSize(10)
                                },
                                splitLine: {
                                    lineStyle: {
                                        color: "rgba(255,255,255,0.1)"
                                    }
                                }
                            }
                        ],
                        series: [
                            {
                                name: "入库",
                                type: "line",
                                data: dataList1,
                                // itemStyle: {
                                //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                //         { offset: 0, color: '#3FC1FF' },
                                //         { offset: 0.5, color: '#3FC1FF' },
                                //         { offset: 1, color: 'rgba(63,193,255,0.26)' }
                                //     ]),
                                //     barBorderRadius: [px16, px16, px16, px16]
                                // },

                                showSymbol: false,
                                areaStyle: {
                                    opacity: 0.3,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        { offset: 0, color: '#378BDC' },
                                        { offset: 1, color: '#3080CB00' }
                                    ]),
                                },

                                lineStyle: {
                                    width: 1
                                },

                                emphasis: {
                                    disabled: false,
                                    itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#378BDC' },
                                            { offset: 1, color: '#3080CB00' }
                                        ]),
                                        shadowColor: "rgba(10,146,255,0.5)"
                                    }
                                }
                            },
                            {
                                name: "出库",
                                type: "line",
                                data: dataList2,
                                showSymbol: false,
                                // itemStyle: {
                                //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                //         { offset: 0, color: '#FBBC05' },
                                //         { offset: 0.5, color: '#FBBC05' },
                                //         { offset: 1, color: 'rgba(63,193,255,0.26)' }
                                //     ]),
                                //     barBorderRadius: [px16, px16, px16, px16]
                                // },


                                lineStyle: {
                                    width: 1
                                },
                                areaStyle: {
                                    opacity: 0.3,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        { offset: 0, color: '#EFBB36' },
                                        { offset: 1, color: '#CCC64400' }
                                    ])
                                },
                                emphasis: {
                                    disabled: false,
                                    itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#EFBB36' },
                                            { offset: 1, color: '#CCC64400' }
                                        ]),
                                        shadowColor: "rgba(10,146,255,0.5)"
                                    }
                                }
                            },
                        ],
                    };
                }
            });
        },
        drawChart() {
            //let option = getOption(this.dataOp);
            this.myChart.setOption(this.dataOp);
        },
        resize() {
            this.myChart.resize();
        }
    }
}
</script>

<style lang="scss" scoped>
.inoutcount {
    width: 100%;
    height: 90%;

    .chart {
        width: 100%;
        height: 100%;
    }
}
</style>